<template>
  <div class="head-card mb-2">
    <div class="head-card-bottom">
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        :variant="$route.name === 'dashboard-partner-stats' ? 'flat-primary' : 'flat-secondary'"
        :to="{ name: 'dashboard-partner-stats', params: { id: $route.params.id } }"
        pill
        exact
      >
        {{ $t('Overview') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        :variant="$route.name === 'dashboard-partner-stats-phoenix' ? 'flat-primary' : 'flat-secondary'"
        :to="{ name: 'dashboard-partner-stats-phoenix', params: { id: $route.params.id } }"
        pill
      >
        {{ $t('Phoenix') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        :variant="$route.name === 'dashboard-partner-stats-dsp' ? 'flat-primary' : 'flat-secondary'"
        :to="{ name: 'dashboard-partner-stats-dsp', params: { id: $route.params.id } }"
        pill
      >
        {{ $t('Dsp') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'StatsNavigation',
  components: {
    BButton,
  },
  directives: {
    Ripple,
  },
}
</script>

<style scoped lang="scss">
.head-card-bottom {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
</style>
